module.exports = __webpack_public_path__ + "static/media/why-we-developed.a2f5564c.png";